import React,{useState,useEffect} from 'react';
import { AppBar,Typography ,Toolbar,Avatar,Button} from '@material-ui/core';
import useStyles from './styles';
import {Link} from 'react-router-dom';
import { useNavigate ,useLocation} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { LOGOUT } from '../../constants/actionTypes';
import decode from 'jwt-decode';
import memoriesLogo from '../../images/memoriesLogo.png';
import memoriesText from '../../images/memoriesText.png';
const Navbar = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const [user,setUser] = useState(JSON.parse(localStorage.getItem('profile')));
   const logout = ()=>{
        dispatch({type:LOGOUT});
        navigate('/');
        setUser(null);
        window.location.reload(false);
   };
   useEffect(() => {
    const token = user?.token;
    
    if (token) {
      const decodedToken = decode(token);

      if (decodedToken.exp * 1000 < new Date().getTime()) logout();
    }

    setUser(JSON.parse(localStorage.getItem('profile')));
  }, [location]);
  return (
    <AppBar className={classes.appBar} position='static' color='inherit'>
        <Link to='/' className = {classes.brandContainer}>
        <img className={classes.image} src={memoriesText} alt='icon' height='45px'/>

        <img className={classes.image} src={memoriesLogo} alt='icon' height='45px'/>
        </Link>
        <Toolbar className={classes.toolbar}>
          {
            user?(
              <div className={classes.profile}>
                <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>
                  {user.result.name.charAt(0)}
                </Avatar>
                <Typography className={classes.userName} variant='h6'>{user.result.name}</Typography>
                <Button variant="contained" className={classes.logout} color='secondary' onClick={logout}>Log Out</Button>
              </div>

            ):(
                <Button component={Link} to="/auth" className = {classes.signin} variant = "contained" color='primary' >Sign In</Button>
            )
          }
        </Toolbar>
      </AppBar>
  )
}

export default Navbar